import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";
import { CLUSTER_LABELS } from "@/lib/constants";

const STATUS_TONE = { Published: "bg-[#667A66]/12 text-[#4d6b4d]", Draft: "bg-[#E5E1D8] text-[#6B665E]",
  "Needs Update": "bg-[#C49A5A]/15 text-[#8a6a2e]", "Awaiting Professional Review": "bg-[#9F634E]/12 text-[#9F634E]" };

export default function AdminContent() {
  const [pages, setPages] = useState([]);
  useEffect(() => { http.get("/admin/content").then((r) => setPages(r.data)).catch(() => {}); }, []);

  const published = pages.filter((p) => p.content_status === "Published").length;

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Editorial Control</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">SEO content architecture</h1>
      <p className="text-[#6B665E] text-sm mb-6">{pages.length} pages across all clusters · {published} published, {pages.length - published} managed drafts (noindex until published).</p>
      <Card className="p-2 overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead><tr className="text-[#8A998C] text-xs uppercase tracking-wide">
            {["Slug", "Cluster", "Target query", "Status", "Index", "Author"].map((h) => <th key={h} className="text-left p-3">{h}</th>)}
          </tr></thead>
          <tbody>
            {pages.map((p) => (
              <tr key={p.id} className="border-t border-[#F0ECE4]">
                <td className="p-3 text-[#1A1918]">/{p.slug}</td>
                <td className="p-3 text-[#6B665E]">{CLUSTER_LABELS[p.cluster] || p.cluster}</td>
                <td className="p-3 text-[#6B665E]">{p.target_query}</td>
                <td className="p-3"><span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_TONE[p.content_status] || "bg-[#E5E1D8] text-[#6B665E]"}`}>{p.content_status}</span></td>
                <td className="p-3 text-[#6B665E]">{p.index_status}</td>
                <td className="p-3 text-[#6B665E]">{p.author?.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
